import { h, Component } from "preact";
import DayPicker from "react-day-picker";
import DayPickerStyleProxy from "./DayPickerStyleProxy";
import customDatePickerStylings from "./DayPickerStyle.css";
import DateSelector from "./DateSelector";
import { css } from "emotion";
import Image from "./Image";
import { connect } from "react-redux";
import { getDates, getNextAvailableDates } from "../state/actions/eventActions";
const dateAvailable = require("../assets/images/dateAvailable.svg");
const dateUnavailable = require("../assets/images/dateUnavailable.svg");

const wrapper = css({
  display: "flex",
  "@media(max-width: 600px)": {
    display: "block"
  }
});

const legendWrapper = css({
  padding: 12,
  "@media(max-width: 600px)": {
    paddingLeft: "calc(50% - 119px)",
    "&:after": {
      content: '""',
      clear: "both",
      display: "block"
    }
  }
});

const legendAvailabilityWrapper = css({
  "@media(max-width: 600px)": {
    float: "left"
  },
  "@media(max-width: 340px)": {
    float: "none"
  }
});

const dateAvailableStyling = css({
  marginLeft: 8,
  verticalAlign: "text-bottom"
});

const legendUnavailableWrapper = css({
  "@media(max-width: 600px)": {
    float: "left",
    marginLeft: 10
  },
  "@media(max-width: 340px)": {
    float: "none",
    marginLeft: 0
  }
});

class CalendarPicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDay: new Date(),
      relevantDates: []
    };
    this.getStartingMonth = this.getStartingMonth.bind(this);
    this.handleDayClick = this.handleDayClick.bind(this);
    this.checkDateDisabled = this.checkDateDisabled.bind(this);
    this.getDateSelection = this.getDateSelection.bind(this);
    this.isUnavailable = this.isUnavailable.bind(this);
    this.isAvailable = this.isAvailable.bind(this);
    this.onMonthChange = this.onMonthChange.bind(this);
  }

  componentWillMount() {
    const { event, getNextAvailableDates } = this.props;
    const date = new Date();
    getNextAvailableDates(event.data._id);
  }

  componentWillReceiveProps(newProps) {
    if (newProps.eventDates.dates && !this.props.eventDates.dates) {
      const firstValidDate = this.getFirstValidDate(newProps.eventDates.dates);
      if (firstValidDate) {
        const { _id, display, startDate } = firstValidDate;
        this.props.selectDate(_id, display, startDate);
        const date = new Date(firstValidDate.startDate);
        const relevantDates = newProps.eventDates.dates[date.getDate()];
        this.setState({
          selectedDay: date,
          relevantDates: relevantDates
        });
      } else {
        const selectedDate = this.getDateSelection(newProps);
        if (selectedDate) {
          const date = new Date(selectedDate.startDate);
          const relevantDates = newProps.eventDates.dates[date.getDate()];
          this.setState({
            selectedDay: date,
            relevantDates: relevantDates
          });
        }
      }
    }
  }

  getFirstValidDate(datesObj) {
    let firstValidDate;
    for (var key in datesObj) {
      const dates = datesObj[key];
      firstValidDate = dates.reduce((cur, date) => {
        if (date.valid && !cur) {
          return date;
        }
        return cur;
      }, undefined);
      if (firstValidDate) {
        break;
      }
    }
    return firstValidDate;
  }

  getDateSelection(props) {
    const { selectedDateId, selectedStartDate } = props;
    const selectedDateDay = new Date(selectedStartDate);
    const datesFallingOnDay =
      props.eventDates.dates[selectedDateDay.getDate()] || [];
    const selectedDate = datesFallingOnDay.find(
      date => date._id === selectedDateId
    );
    return selectedDate;
  }

  getRelevantDates(monthDays, day) {
    const calendarDate = day;
    return monthDays[calendarDate.getDate()] || [];
  }

  checkDateDisabled(day) {
    const { dates } = this.props.eventDates;
    if (dates) {
      const isContainedInEvent =
        dates[day.getDate()] && dates[day.getDate()].length > 0;
      //.filter(date => date.valid)
      return !isContainedInEvent;
    }
    return false;
  }

  handleDayClick(day, { selected, disabled }) {
    if (disabled) {
      // Day is disabled, do nothing
      return;
    }
    const relevantDates = this.props.eventDates.dates[day.getDate()] || [];
    if (selected) {
      // Unselect the day if already selected
      this.setState({
        selectedDay: undefined
      });
      return;
    }
    const validDates = relevantDates.filter(date => date.valid);
    if (validDates.length > 0) {
      const { _id, display, startDate } = validDates[0];
      this.props.selectDate(_id, display, startDate);
    }
    if (validDates.length > 0) {
      const selectedDate = validDates[0];
      const date = new Date(selectedDate.startDate);
      this.setState({
        selectedDay: date,
        relevantDates: relevantDates
      });
    }
  }

  getStartingMonth() {
    //todo fix this
    return new Date();
  }

  onMonthChange(month) {
    const { event, getDates } = this.props;
    const date = new Date(month);
    getDates(event.data._id, date.getMonth(), date.getFullYear(), date);
  }

  isUnavailable(day) {
    const { dates } = this.props.eventDates;
    if (dates) {
      const sessionsInDay = dates[day.getDate()] || [];
      if (sessionsInDay.length > 0) {
        return (
          sessionsInDay.filter(date => !date.valid).length ===
          sessionsInDay.length
        );
      }
    }
    return false;
  }

  isAvailable(day) {
    const { dates } = this.props.eventDates;
    if (dates) {
      const sessionsInDay = dates[day.getDate()] || [];
      if (sessionsInDay.length > 0) {
        return sessionsInDay.filter(date => date.valid).length > 0;
      }
      return false;
    }
  }

  render() {
    const { selectedDay, relevantDates } = this.state;
    const { selectedDateId, selectDate, eventDates } = this.props;
    const { dates, loading, month } = eventDates;
    const floatLeft = css({
      // "@media(max-width: 600px)": {
      //   float: "none",
      //   display: "block"
      // }
    });
    return (
      <div>
        <label for="date-selector">
          <h3>Select Date</h3>
        </label>
        <div className={wrapper}>
          <div className={floatLeft}>
            {loading ? (
              <div className={floatLeft}>
                <div className={customDatePickerStylings.CustomDayPicker}>
                  <div
                    className={
                      customDatePickerStylings["CustomDayPicker-wrapper"]
                    }
                  >
                    <div
                      className={
                        customDatePickerStylings["CustomDayPicker-Months"]
                      }
                    >
                      <div
                        class="loading loading-lg"
                        style={{ width: 294, height: 234 }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <DayPicker
                className={floatLeft}
                classNames={DayPickerStyleProxy}
                selectedDays={selectedDay}
                month={month}
                onDayClick={this.handleDayClick}
                disabledDays={this.checkDateDisabled}
                onMonthChange={this.onMonthChange}
                modifiers={{
                  [DayPickerStyleProxy.available]: this.isAvailable,
                  [DayPickerStyleProxy.unavailable]: this.isUnavailable
                }}
              />
            )}
          </div>
          <div className={floatLeft}>
            <DatePickerLegend className={floatLeft} />
          </div>
        </div>
        <DateSelector
          name={"Select Time"}
          dates={relevantDates || []}
          selectDate={selectDate}
          selectedDateId={selectedDateId}
        />
        {relevantDates.length === 1 ? (
          <div style={{ marginBottom: 15 }}>
            <h2>Selected Date</h2>
            {relevantDates[0].display.time}, {relevantDates[0].display.date}
          </div>
        ) : null}
      </div>
    );
  }
}

export default connect(
  state => ({
    event: state.event,
    eventDates: state.eventDates
  }),
  {
    getDates,
    getNextAvailableDates
  }
)(CalendarPicker);

const DisableDate = css({
  backgroundColor: "#f7faff",
  marginTop: 20,
  marginLeft: 12,
  "@media(max-width: 600px)": {
    marginLeft: 0
  }
});

const DatePickerLegend = () => {
  return (
    <div className={DisableDate}>
      <div className={legendWrapper}>
        <div className={legendAvailabilityWrapper}>
          <Image src={dateAvailable} />
          <span className={dateAvailableStyling}>Date Available</span>
        </div>
        {/* for the time being we dont need the unavailable date field */}
        <div className={legendUnavailableWrapper}>
          <Image src={dateUnavailable} />
          <span className={dateAvailableStyling}>Date Unavailable</span>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./components/CalendarPicker.js